module.exports = __webpack_public_path__ + "img/logo.a49a4e09.png";